import styled from 'styled-components';

import { Colors, Styling } from '../../constants';

// Amber with dark text rather than the usual white-on-dark chrome: this has to read as
// a standing warning that the session is not the admin's own.
export const Banner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  height: ${Styling.IMPERSONATION_BANNER_HEIGHT}px;
  padding: 0 16px;
  background-color: ${Colors.WARNING};
  color: ${Colors.BLACK_90};
  font-size: ${Styling.HEADER_FONT_SIZE}px;
`;

export const BannerText = styled.span`
  strong {
    font-weight: 600;
  }
`;

// A chip rather than more parenthesised text: the banner is already a run of two emails,
// and the role is the one part an admin scans for. Bordered rather than filled so it reads
// as a label on the amber ground instead of competing with the End button.
export const RoleTag = styled.span`
  display: inline-block;
  margin-left: 6px;
  padding: 0 6px;
  border: 1px solid ${Colors.WARNING_BORDER};
  border-radius: ${Styling.DEFAULT_BORDER_RADIUS}px;
  font-size: ${Styling.HEADER_FONT_SIZE - 2}px;
  font-weight: 600;
  vertical-align: baseline;
  white-space: nowrap;
`;

export const EndButton = styled.button`
  padding: 2px 10px;
  border: 1px solid ${Colors.WARNING_BORDER};
  border-radius: ${Styling.DEFAULT_BORDER_RADIUS}px;
  background-color: ${Colors.WARNING_DARKER};
  color: ${Colors.BLACK_90};
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: default;
  }
`;
